import { _ } from '@swc/helpers/esm/_instanceof.js';

function isDomElement(object) {
    return _(object, HTMLElement) || Boolean(object) && object.nodeType > 0;
}

export { isDomElement };
